optionsInput